import React from "react";
import { SettingsListPage as SharedSettingsListPage, type SettingsListPageProps as SharedSettingsListPageProps } from "../../../../../shared/frontend/settings/SettingsListPage";
import { useSettingsListRuntime } from "./useSettingsListRuntime";
export { SettingsListCardHeader } from "../../../../../shared/frontend/settings/SettingsListPage";
export type {
  ProColumnsWithMeasure, SettingsListRequest, SettingsListRequestParams, SettingsListDataMode, SettingsListActionRef,
  RowOverlaySpec, SettingsListRowState, ColumnDefinition,
} from "../../../../../shared/frontend/settings/SettingsListPage";
export type SettingsListPageProps<T extends object> = Omit<SharedSettingsListPageProps<T>, "runtime" | "scopeWidenHint"> & { studioScopeWidenHint?: boolean };

/**
 * m1member-Adapter: Laufzeit aus `useSettingsListRuntime` (Anmeldung, Studiokontext, Serverpräferenzen,
 * Darstellung "rows" statt Antd-Tabelle, plans/2026-10-12-antd-rueckbau.md Stufe 3).
 */
export function SettingsListPage<T extends object>({ studioScopeWidenHint, ...props }: SettingsListPageProps<T>) {
  const runtime = useSettingsListRuntime({ withScope: true });
  return <SharedSettingsListPage<T> {...props} scopeWidenHint={studioScopeWidenHint} runtime={runtime} />;
}
